import React from "react";
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import StoreTitle from "../../../component/StoreTitle";

const CustomerHero = ({ activeTab }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/reports")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title="Customer Database" />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          marginBottom: 3,
        }}
      >
        <Button
          variant={activeTab === "details" ? "contained" : "outlined"}
          onClick={() => navigate("/reports/customer-details")}
        >
          Customer Details
        </Button>
        <Button
          variant={activeTab === "history" ? "contained" : "outlined"}
          onClick={() => navigate("/reports/customer-history")}
        >
          Customer History
        </Button>
      </Box>
    </Box>
  );
};

export default CustomerHero;
